import React from 'react';
import { GroupLabel } from 'components/MenuList';
var NavMenuItemGroup = function NavMenuItemGroup(_ref) {
  var label = _ref.label,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GroupLabel, {
    as: "li"
  }, label), children);
};
export default NavMenuItemGroup;